module.exports = __webpack_public_path__ + "static/media/infoJumbo1.11b90135.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fanuc/images/infoJumbo1.png
// module id = 586
// module chunks = 0